export enum ChangeSpecsStep {
    SelectSpec,
    SelectMenus,
    ReviewChanges,
    Confirmation,
}

export interface CombinedSpec {
    currentSpecNo: number;
    currentDescription: string;
    desiredSpecNo: number;
    desiredDescription: string;
}